import { ReactNode, useRef } from 'react';

import { useOnClickOutside } from 'app/hooks';


import styles from './Dropdown.module.scss';

type DropdownT = {
  dropdown: boolean;
  onClickOutside: (e: Event) => void;
  children: ReactNode;
};

export const Dropdown = ({ dropdown, onClickOutside, children }: DropdownT) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(menuRef, onClickOutside);

  return (
    <div
      className={styles.dropdown}
      ref={menuRef}
      data-show={dropdown}>
      <ul className={styles.list}>{children}</ul>
    </div>
  );
};
